import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import scormFilesReducer from './scormFilesSlice';

export const appReducer = combineReducers({
    auth: authReducer,
    scormFiles: scormFilesReducer,
});
